import ValidatorFunctions from "../validation/ValidatorFunctions"

const positionCustomization = {
    namespaced: true,
    state:      function () {
        return {
            customization: {},
            icon:              {},
            color:             {},
            scale:             {},
            text:              '',
            fontFamily:        '',
            fontSize:          ''
        }
    },
    getters:    {
        /**
         * Check, if the position has a customizationType enabled
         *
         * @param state
         * @returns {boolean}
         */
        hasCustomization: state => {
            return !ValidatorFunctions.isEmpty(state.customization)
        },

        /**
         * Check if the position has an icon customization
         *
         * @param state
         * @param getters
         * @returns {boolean}
         */
        hasIconCustomization: (state, getters) => {
            if (getters.hasCustomization) {
                return state.customization.getDescription() === 'mytw_conf_position_customization_icon'
            }

            return false
        },

        /**
         * Check if the the position has an upload customization
         *
         * @param state
         * @param getters
         * @returns {boolean}
         */
        hasUploadCustomization: (state, getters) => {
            if (getters.hasCustomization) {
                return state.customization.getDescription() === 'mytw_conf_position_customization_upload'
            }

            return false
        },

        /**
         * Check if the position has a text customization
         *
         * @param state
         * @param getters
         * @returns {boolean}
         */
        hasTextCustomization: (state, getters) => {
            if (getters.hasCustomization) {
                return state.customization.getDescription() === 'mytw_conf_position_customization_text'
            }

            return false
        },

        /**
         * Check if the position has no customization at all
         *
         * @param state
         * @param getters
         * @returns {boolean}
         */
        hasNoneCustomization: (state, getters) => {
            if (getters.hasCustomization) {
                return state.customization.getDescription() === 'mytw_conf_position_customization_none'
            }

            return false
        },

        /**
         * Check if the position has a selected color
         * @param state
         * @returns {boolean}
         */
        hasColor: state => {
            return !ValidatorFunctions.isEmpty(state.color)
        },

        /**
         * Check if the position has a selected scale
         *
         * @param state
         * @returns {boolean}
         */
        hasScale: state => {
            return !ValidatorFunctions.isEmpty(state.scale)
        },

        /**
         * Returns true if the state.text property is not an empty string, null or undefined.
         *
         * @param state
         * @returns {boolean}
         */
        hasText: state => {
            return !ValidatorFunctions.isEmpty(state.text)
        },

        /**
         * Returns true if the state.fontFamily property is not an empty string, null or undefined
         *
         * @param state
         * @returns {boolean}
         */
        hasFontFamily: state => {
            return !ValidatorFunctions.isEmpty(state.fontFamily)
        },

        /**
         * Returns true if the state.fontScale property is not an empty string, null or undefined.
         *
         * @param state
         * @returns {boolean}
         */
        hasFontSize: state => {
            return !ValidatorFunctions.isEmpty(state.fontScale)
        },

        /**
         * Returns true if the state.icon property is not an empty string, null or undefined
         * @param state
         * @returns {boolean}
         */
        hasIcon: state => {
            return !ValidatorFunctions.isEmpty(state.icon)
        }
    },
    mutations:  {
        /**
         * Update the type of customization for the position
         *
         * @param state
         * @param customization
         */
        updateCustomization: function (state, customization) {
            state.customization = customization
        },

        /**
         * Update the selected icon for the position
         * @param state
         * @param icon
         */
        updateIcon: function (state, icon) {
            state.icon = icon
        },

        /**
         * Update the color for the positon
         *
         * @param state
         * @param color
         */
        updateColor: function (state, color) {
            state.color = color
        },

        /**
         * Update the scale for the position
         *
         * @param state
         * @param scale
         */
        updateScale: function (state, scale) {
            state.scale = scale
        },

        /**
         * Update the text for the position
         *
         * @param state
         * @param text
         */
        updateText: function (state, text) {
            state.text = text
        },

        /**
         * Update the font family of the position
         *
         * @param state
         * @param fontFamily
         */
        updateFontFamily: function (state, fontFamily) {
            state.fontFamily = fontFamily
        },

        /**
         * Updates the font size of the position
         *
         * @param state
         * @param fontSize
         */
        updateFontSize: function (state, fontSize) {
            state.fontSize = fontSize
        }
    }
}

export default positionCustomization
